import { DenormalizedCustomizableQuestion } from '@packages/types'
import React from 'react'

import useThemeSettings from 'customizer/theme/useThemeSettings'
import SanitizedHtml from 'themes/common/components/SanitizedHtml'

import Summary from '../Summary'

import './Step.scss'

interface QuestionStepHeaderProps {
  question: DenormalizedCustomizableQuestion
  questionStyle: {
    color: string
    fontSize: string
    fontFamily?: string
  }
  descriptionStyle: {
    color: string
    fontSize: string
    fontFamily?: string
  }
  headerStyle: {
    borderBottomColor: string
    borderBottomWidth: string
    paddingBottom: string
  }
}

const QuestionStepHeader = ({ question, questionStyle, descriptionStyle, headerStyle }: QuestionStepHeaderProps) => {
  const summaryStyle = useThemeSettings('summary')
  const { linkColor } = useThemeSettings('questionPanel')

  return (
    <>
      <div className="step__header" style={headerStyle}>
        <div className="step__header-title" style={questionStyle}>
          {question?.name}
        </div>
        <Summary
          question={question}
          style={{
            fontFamily: summaryStyle.fontFamily?.fontFamily,
            color: summaryStyle.color,
            fontSize: summaryStyle.fontSize,
          }}
        />
      </div>
      {question.description && question.showDescription && (
        <SanitizedHtml
          dirtyHtml={question.description}
          className="step__description"
          style={descriptionStyle}
          tagsStyle={{ a: `color: ${linkColor};` }}
        />
      )}
    </>
  )
}

export default QuestionStepHeader
